/**
 * @module views\sys\db\templates\dynamicProperty\actionsProperty
 */
import Vue from "vue";
import Component from "vue-class-component";
import BaseEditor from "../../base";
import { Watch } from "vue-property-decorator";

@Component
export default class ActionsProperty extends BaseEditor {
  /**
   * 更新actions
   */
  @Watch("model", { deep: true })
  private updateData() {
    if (this.model) {
    }
    this.setIntialActions();
  }

  /**
   * 删除
   * @param index
   */
  private deleteAction(index: number) {
    let lst = this.model.actions as IRowAction[];
    lst.splice(index, 1);
  }

  private insertAction(Index: number) {
    let lst = this.model.actions as IRowAction[];
    lst.splice(Index, 0, {
      icon: "mdi-selection",
      text: "请输入操作名称"
    });
  }

  private moveUpAction(index) {
    let lst = this.model.actions as IRowAction[];
    let action = lst[index];
    lst.splice(index, 1);
    lst.splice(index - 1, 0, action);
  }
  private moveDownAction(index) {
    let lst = this.model.actions as IRowAction[];
    let action = lst[index];
    lst.splice(index, 1);
    lst.splice(index + 1, 0, action);
  }

  /**
   * 新增
   */
  private addAction() {
    if (this.model) {
      let actions = this.model.actions as IRowAction[];
      actions.push({
        icon: "edit",
        text: "",
        event: "",
        color: "primary"
      });
    }
  }

  created() {
    this.setIntialActions();
  }

  /**
   * 设置初始化actions
   */
  private setIntialActions() {
    if (this.model && !this.model.actions) {
      let type = this.model.type;
      let json = "";
      if (type === "O-sort") {
        json = JSON.stringify(this.sortActions);
      } else if (type === "actions") {
        json = JSON.stringify(this.initalActions);
      }
      if (json) {
        let actions = JSON.parse(json);
        this.$set(this.model, "actions", actions);
      }
    }
  }

  private initalActions = [
    {
      icon: "list",
      value: "view",
      text: "查看明细",
      hide: false,
      event: "viewItem",
      color: "primary"
    },
    {
      icon: "mdi-content-copy",
      value: "copy",
      text: "复制本记录",
      hide: false,
      event: "copyItem"
    },
    {
      value: "edit",
      icon: "edit",
      text: "编辑本记录",
      event: "editItem"
    },
    {
      value: "delete",
      icon: "delete",
      text: "删除本记录",
      event: "deleteItem"
    }
  ];

  private sortActions = [
    {
      icon: "mdi-arrow-up",
      value: "moveupItem",
      text: "上移",
      hide: false,
      event: "moveupItem",
      color: "success"
    },
    {
      icon: "mdi-arrow-down",
      value: "movedownItem",
      text: "下移",
      hide: false,
      event: "movedownItem",
      color: "success"
    }
  ];
}
